import { Component, Input, OnInit} from '@angular/core';
import {DocumentoPac} from 'src/app/model/DocumentoPac';
import {OprecaoService} from '../../../services/operacao.service'
import { Operacao } from 'src/app/model/Operacao';

@Component({
  selector: 'app-informacoes-da-operacao-e-garantias',
  templateUrl: './informacoes-da-operacao-e-garantias.component.html',
  styleUrls: ['./informacoes-da-operacao-e-garantias.component.scss'],
  standalone: false
})
export class InformacoesDaOperacaoEGarantiasComponent implements OnInit {

  @Input() documentoPac: DocumentoPac = new DocumentoPac();

  operacao: Operacao = new Operacao();
  
  constructor(private operacaoService : OprecaoService) { }

  ngOnInit(): void {
    this.operacaoService.obterOperacao(this.documentoPac.id).subscribe(
      (operacao) =>{
        this.operacao = operacao;
      },
      (error)=>{
        console.error(`Erro ao pesquisar operacao: ${error}`);
      }
    );
  }

  public get totalfinanciado(){
    return (Number(this.documentoPac?.valorFinanciadoFname) + Number(this.documentoPac?.valorInstituicaoCredenciada) + Number(this.documentoPac?.valorParticipacaoFinaciado))
  }

  public get percetFinaciadoFname(){
    return (Number(this.documentoPac?.valorFinanciadoFname)/this.totalfinanciado)*100;
  }

  public get percetInstituicaoCredenciada(){
    return (Number(this.documentoPac?.valorInstituicaoCredenciada)/this.totalfinanciado)*100;
  }

  public get percetParticipacaoFinaciado(){
    return (Number(this.documentoPac?.valorParticipacaoFinaciado)/this.totalfinanciado)*100;
  }

  public get totalMesesPrazos(){
    return Number(this.documentoPac?.mesesCarencia) + Number(this.documentoPac?.mesesAmortizacao);
  }

  public get isTaxaEfetiva(){
    if(this.operacao.idUnidadeMonetariaCobranca == 19 || this.operacao.idUnidadeMonetariaCobranca == 604){
      return true;
    }
    return false;
  }

  public get isTaxaEfetiva2(){
    if(this.operacao.idUnidadeMonetariaCobranca2 == 19 || this.operacao.idUnidadeMonetariaCobranca2 == 604){
      return true;
    }
    return false;
  }

  public get isTaxaEfetiva3(){
    if(this.operacao.idUnidadeMonetariaCobranca3 == 19 || this.operacao.idUnidadeMonetariaCobranca3 == 604){
      return true;
    }
    return false;
  }

  public get modalidadeDeJuros(){
    if(this.documentoPac?.idModalidadeDeJuros){
      if(this.documentoPac?.idModalidadeDeJuros == 1){
        return 'Capitalizado';
      }

      if(this.documentoPac?.idModalidadeDeJuros == 2){
        return 'Exigível';
      }
    }
    return '-';
  }
}
